<template>
  <div v-if="selectedItems.length < 3">
    <component
      :is="buttonComponent"
      v-for="item in selectedItems"
      :item="item"
      :key="item.id"
      :deletable="false"
      :selectable="false"
    />
  </div>
  <div v-else>
    <component :is="iconComponent" />
    <span class="title"
      >{{ selectedItems.length }} {{ $t(`filter.filters.${filterName}.label`, selectedItems.length) }}</span
    >
  </div>
</template>
<script lang="ts">
import { AnyEntity } from '@/types';
import { Component, defineAsyncComponent, defineComponent, PropType } from 'vue';

export default defineComponent({
  name: 'FilterValueDisplay',

  props: {
    filterName: {
      type: String,
      required: true,
    },

    /**
     * Component to render for each selected item in the button that toggles
     * the selection list
     */
    buttonComponent: {
      type: String,
      required: false,
      default: 'CodePill',
    },

    selectedItems: {
      type: Array as PropType<Array<AnyEntity>>,
      required: true,
    },
  },

  computed: {
    entityType() {
      return this.filterName.slice(0, -6);
    },

    // dynamically register the icon component to avoid having to include here
    // all the icon components that are used
    iconComponent(): () => Promise<Component> {
      const name = this.entityType.endsWith('Group') ? 'GroupIcon16' : `${this.entityType}Icon16`;

      return defineAsyncComponent(() => import(`@/components/Icons/${name}.vue`));
    },
  },
});
</script>
<style lang="scss" scoped>
.title {
  padding-left: 4px;
}
</style>
